module.exports = __webpack_public_path__ + "static/media/map-image.f990e231.png";